// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "claire_confirmation_token".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { claireConfirmationActionValues } from '@borradh-workspace/labels';
/** Response atom for the "claire_confirmation_token" table (1:1 with a DB row, on the wire). */
export const claireConfirmationTokenAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    conversationId: z.string(),
    action: z.enum(claireConfirmationActionValues),
    resourceId: z.string(),
    payload: z.unknown().nullable(),
    consumedAt: z.string().datetime().nullable(),
    createdInMessageId: z.string().nullable(),
    approvedInMessageId: z.string().nullable(),
    expiresAt: z.string().datetime(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=claireConfirmationToken.js.map